<div class="mc-modal__content">
	<div class="mc-modal__close" (click)="closeDialog()"></div>
	<div class="mc-modal__title"
		 [ngClass]="{'to-portrait': data === rotateTypes.to_portrait}">{{ 'modals.rotate_device.title' | translate }}
	</div>
</div>
